import { Block, Link, Navbar, NavLeft, NavTitle, Page } from 'framework7-react';
import React, { FC } from 'react';
import style from './DrivingDailyDataStyle.module.css';
import { DataList } from '@/components/projects/DataList/DataList';

export const DrivingDailyData: FC = () => {
  interface DataType {
    date?: string;
    PrevDate?: string;
    fullDate?: string;
    drivingDistance?: string;
    daytimeDrivingDuration?: string;
    nightDrivingDuration?: string;
    drivingTimes?: string;
    suddenSatrt?: string;
    suddenBraking?: string;
  }

  interface LabelListType {
    label: string;
    props: keyof DataType;
  }

  // APIで取得
  const drivingDailyData = {
    date: '20日',
    PrevDate: '17日',
    fullDate: '1月20日',
    drivingDistance: '0.0km',
    daytimeDrivingDuration: '3分',
    nightDrivingDuration: '0分',
    drivingTimes: '1回',
    suddenSatrt: '0回',
    suddenBraking: '0回',
  };

  const labelList: LabelListType[] = [
    {
      label: '走行距離',
      props: 'drivingDistance',
    },
    {
      label: '走行時間(日中)',
      props: 'daytimeDrivingDuration',
    },
    {
      label: '走行時間(夜間)',
      props: 'nightDrivingDuration',
    },
    {
      label: '運転回数',
      props: 'drivingTimes',
    },
    {
      label: '急アクセル回数',
      props: 'suddenSatrt',
    },
    {
      label: '急ブレーキ回数',
      props: 'suddenBraking',
    },
  ];

  return (
    <Page name="DrivingDailyData">
      <Navbar>
        <NavLeft>
          <Link back animate>
            <i className="icon-left" />
          </Link>
        </NavLeft>
        <NavTitle>ドライブ</NavTitle>
      </Navbar>
      <Block>
        <div
          className={`${style['day_nav']} u-font-size-xxl u-margin-bottom-sm`}
        >
          <div className={`${style['day-nav-div']} before-day`}>
            <i className="icon-left" />
            <span>{drivingDailyData.PrevDate}</span>
          </div>
          <div className={`${style['current-day']} current-day`}>
            {drivingDailyData.fullDate}
          </div>
        </div>
        <div className="info-card info-card-elevated data-list">
          <DataList
            labelList={labelList}
            data={drivingDailyData}
            title={`【${drivingDailyData.date}のサマリー】`}
          />
        </div>
      </Block>
    </Page>
  );
};
